import { toast } from "@/components/common/Toast"
import { moduleTranslate } from "@/utils/moduleTranslate"

const SERVER_ERROR_TOAST_ID = "server-error"

/**
 * Shows a toast for 5xx server errors with a truncated reference ID.
 * 4xx errors are handled by components with contextual translated messages.
 */

export function toastServerError(
  status: number,
  requestId: string | null,
): void {
  try {
    if (status < 500) return

    const ref = requestId ? requestId.slice(0, 8) : "unknown"
    toast.error(moduleTranslate("ERROR/SERVER_ERROR_REFERENCE", { ref }), {
      id: SERVER_ERROR_TOAST_ID,
    })
  } catch {
    // never block UI
  }
}
